export const version = "sha2/5.0.7";
//# sourceMappingURL=_version.js.map